import { render, staticRenderFns } from "./ElementStickerEditionModal.vue?vue&type=template&id=87f73a54&scoped=true"
import script from "./ElementStickerEditionModal.vue?vue&type=script&lang=js"
export * from "./ElementStickerEditionModal.vue?vue&type=script&lang=js"
import style0 from "./ElementStickerEditionModal.vue?vue&type=style&index=0&id=87f73a54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f73a54",
  null
  
)

export default component.exports